<template>
  <div>
    <el-dialog
        :title="'Chi tiết phiếu bé ngoan'"
        :visible.sync="isOpenDetailTicketAppDialog"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="3vh"
        border
    >
      <el-form
          label-width="140px"
          :model="detailTicketData"
          label-position="left"
          :rules="rules"
          ref="detailTicketData"
      >
        <el-row :gutter="50">
          <el-col :span="12">
            <div class="grid-content">
              <el-form-item prop="nameTicket" label-width="170px">
                <template #label>
                  <span>Tên phiếu bé ngoan</span>
                </template>
                <el-input
                    readonly
                    v-model="detailTicketData.nameTicket"
                    placeholder="Nhập tên template"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <el-form-item label="Mô tả" prop="descriptionTicket" label-width="80px">
                <el-input
                    readonly
                    v-model="detailTicketData.descriptionTicket"
                    placeholder="Nhập mô tả"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row style="
         display: flex;
         flex-wrap: wrap;
         width: 100%;
         margin-top: 10px;
         border: 1px solid rgb(96 99 102 / 19%);
         overflow-y: scroll;
         max-height: 600px;
         padding-left: 50px;
         min-height: 334px"
        >
          <div v-for="item in listTicket"
               :key="item.id"
               style="flex: 0 0 223px; margin: 30px; width: 223px; cursor: pointer"
               @click="showListImageTicket(item)"
          >
            <div class="inline-block-div" >
              <el-image
                  :src="item.urlPicture"
                  style="width: 250px; height: 200px"
              ></el-image>
            </div>
            <div v-if="item.numberPicture !== 0">
              <h4
                  style="color: #30313499; text-align: left; margin-left: 5px;  overflow: hidden; max-height: 20px;
                  text-overflow: ellipsis; white-space: nowrap;"
              >{{showNameGroupPicture(item.namePicture)}}</h4>
              <span style="margin-right: 5px; float: left" class="demonstration">
                      {{item.numberPicture}}<i
                  class="el-icon-picture"
                  style="color: #6298d0"></i>
                    </span>
            </div>
          </div>
        </el-row>
        <div class="tab-infor-button">
          <el-button
              type="danger"
              size="medium"
              @click="closeDialogByButton('detailTicketData')"
          >
            <i class="el-icon-circle-close"/>
            <span>Đóng</span>
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <div>
      <DetailTicketDialog
          :showDetailTicket = "showDetailTicket"
          :titleTicket = "titleTicket"
          :listTicketDetail = "listTicketDetail"
          @close = "handelCloseDetailTicketDialog"
      />
    </div>
  </div>

</template>

<script>
import {listTicketRequest, parentScreenList, plusScreenList, teacherScreenList} from "@/constant/listTemplate";
import templateConfigMixin from "@/global/mixinTemplate/templateConfig.mixin";
import DetailTicketDialog from "@/views/master/school/templateApp/dialog/DetailTicketDialog.vue";
import TicketService from "@/services/TicketService";

export default {
  components: {DetailTicketDialog},
  props: {
    isOpenDetailTicketAppDialog: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      detailTicketData: {
        nameTicket: "",
        descriptionTicket: "",
      },
      rules: {

      },
      plusScreenList,
      teacherScreenList,
      parentScreenList,
      listTicketLearn: [],
      listTicketEat: [],
      listTicketSleep: [],
      listTicketToilet: [],
      listTicketHealthy: [],
      listTicketComment: [],
      listTicketWeek: [],
      listTicketMonth: [],
      listTicketPeriodic: [],
      listTicket: [],
      listTicketRequest,
      showDetailTicket: false,
      titleTicket: '',
      listTicketDetail: [],
      colorText: '',
    };
  },
  mixins: [
    templateConfigMixin
  ],
  computed: {
    screenList() {
      if (this.detailTicketData.appType === "plus") {
        return this.plusScreenList
      } else if (this.detailTicketData.appType === "teacher") {
        return this.teacherScreenList
      } else {
        return this.parentScreenList
      }
    }
  },
  methods: {
    resetFormData() {
      this.$refs["detailTicketData"].resetFields();
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },

    closeDialog() {
      this.$refs["detailTicketData"].resetFields();
      this.handleClearList()
      this.$emit("dialog-close");
    },
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.handleClearList();
      this.listTicket = [];
      this.$emit("dialog-close");
    },
    handleClearList(){
      this.listTicketLearn= []
      this.listTicketEat= []
      this.listTicketSleep= []
      this.listTicketToilet= []
      this.listTicketHealthy= []
      this.listTicketComment= []
      this.listTicketWeek= []
      this.listTicketMonth= []
      this.listTicketPeriodic= []
      this.typePackage = "template"
      for (let i = 0; i < this.plusScreenList.length; i++) {
        this.plusScreenList[i].file = null;
        this.plusScreenList[i].url = '';
        this.plusScreenList[i].showFile = true;
        this.plusScreenList[i].id = null
        this.plusScreenList[i].showFile = true
        this.plusScreenList[i].disabled = false
        this.plusScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        this.teacherScreenList[i].file = null;
        this.teacherScreenList[i].url = "";
        this.teacherScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        this.parentScreenList[i].file = null;
        this.parentScreenList[i].url = '';
        this.parentScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
    },

    getDataInitialDetailTicketAppDialog(row) {
      const id = row.id;
      this.detailTicketData.descriptionTicket = row.descriptionTicket;
      this.detailTicketData.nameTicket = row.nameTicket;
      TicketService.getDetailTicketMasterSchool(id)
          .then((resp) => {
            this.listTicketLearn = resp.data.data.listTicketLearn
            this.listTicketEat = resp.data.data.listTicketEat
            this.listTicketSleep = resp.data.data.listTicketSleep
            this.listTicketToilet = resp.data.data.listTicketToilet
            this.listTicketHealthy = resp.data.data.listTicketHealthy
            this.listTicketComment = resp.data.data.listTicketComment
            this.listTicketWeek = resp.data.data.listTicketWeek
            this.listTicketMonth = resp.data.data.listTicketMonth
            this.listTicketPeriodic = resp.data.data.listTicketPeriodic
            // if (this.detailTicketData.appType === "plus") {
            //   for (let i = 0; i < this.plusScreenList.length; i++) {
            //     let plusTemplate = this.plusScreenList[i];
            //     let key = this.plusScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         plusTemplate.url = data.urlPicture
            //       }
            //     }
            //   }
            // } else if (this.detailTicketData.appType === "teacher") {
            //   for (let i = 0; i < this.teacherScreenList.length; i++) {
            //     let teacherTemplate = this.teacherScreenList[i];
            //     let key = this.teacherScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         teacherTemplate.url = data.urlPicture
            //       }
            //     }
            //   }
            // } else {
            //   for (let i = 0; i < this.parentScreenList.length; i++) {
            //     let parentTemplate = this.parentScreenList[i];
            //     let key = this.parentScreenList[i].key;
            //     for (let j = 0; j < dataList.length; j++) {
            //       let data = dataList[j];
            //       if (data.namePicture === key) {
            //         parentTemplate.url = data.urlPicture
            //       }
            //     }
            //   }
            // }
            this.addTicket();
          })
          .catch((err) => {
            console.log(err);
          });
    },

    addTicket() {
      const listTicket = this.listTicket;

      if (this.listTicketLearn.length > 0) {
        listTicket.push(
            {
              ...this.listTicketLearn[0],
              numberPicture: this.listTicketLearn.length
            }
        );
      }

      if (this.listTicketEat.length > 0) {
        listTicket.push({
          ...this.listTicketEat[0],
          numberPicture: this.listTicketEat.length
        });
      }

      if (this.listTicketSleep.length > 0) {
        listTicket.push({
          ...this.listTicketSleep[0],
          numberPicture: this.listTicketSleep.length
        });
      }

      if (this.listTicketToilet.length > 0) {
        listTicket.push({
          ...this.listTicketToilet[0],
          numberPicture: this.listTicketToilet.length
        });
      }

      if (this.listTicketHealthy.length > 0) {
        listTicket.push({
          ...this.listTicketHealthy[0],
          numberPicture: this.listTicketHealthy.length
        });
      }

      if (this.listTicketComment.length > 0) {
        listTicket.push({
          ...this.listTicketComment[0],
          numberPicture: this.listTicketComment.length
        });
      }

      if(this.listTicketWeek.length > 0) {
        listTicket.push({
          ...this.listTicketWeek[0],
          numberPicture: this.listTicketWeek.length
        });
      }

      if(this.listTicketMonth.length > 0) {
        listTicket.push({
          ...this.listTicketMonth[0],
          numberPicture: this.listTicketMonth.length
        });
      }

      if(this.listTicketPeriodic.length > 0) {
        listTicket.push({
          ...this.listTicketPeriodic[0],
          numberPicture: this.listTicketPeriodic.length
        });
      }
    },

    showListImageTicket(item){
      console.log(item)

      switch (item?.namePicture) {
        case "ticketLearn":
          this.listTicketDetail = this.listTicketLearn;
          break;
        case "ticketEat":
          this.listTicketDetail = this.listTicketEat;
          break;
        case "ticketSleep":
          this.listTicketDetail = this.listTicketEat;
          break;
        case "ticketToilet":
          this.listTicketDetail = this.listTicketToilet;
          break;
        case "ticketHealthy":
          this.listTicketDetail = this.listTicketHealthy;
          break;
        case "ticketComment":
          this.listTicketDetail = this.listTicketComment;
          break;
        case "ticketWeek":
          this.listTicketDetail = this.listTicketWeek;
          break;
        case "ticketMonth":
          this.listTicketDetail = this.listTicketMonth;
          break;
        case "ticketPeriodic":
          this.listTicketDetail = this.listTicketPeriodic;
      }

      this.titleTicket = this.showNameGroupPicture(item?.namePicture)
      this.showDetailTicket = true
    },
    handelCloseDetailTicketDialog(){
      this.showDetailTicket = false
    },

    showImageTemplate(row) {
      if (this.detailTicketData.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].url = row.url;
            this.plusScreenList[i].dialogImg = true;
          }
        }
      } else if (this.detailTicketData.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].url = row.url;
            this.teacherScreenList[i].dialogImg = true;
          }
        }
      } else {
        for (let i = 0; i < this.detailTicketData.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].url = row.url;
            this.parentScreenList[i].dialogImg = true;
          }
        }
      }
    },

    showNameGroupPicture(name) {
      switch (name) {
        case "ticketLearn":
          return "Học tập và rèn luyện";
        case "ticketEat":
          return "Ăn uống";
        case "ticketSleep":
          return "Ngủ nghỉ";
        case "ticketToilet":
          return "Vệ sinh";
        case "ticketHealthy":
          return "Sức khoẻ";
        case "ticketComment":
          return "Nhận xét chung";
        case "ticketWeek":
          return "Nhận xét tuần";
        case "ticketMonth":
          return "Nhận xét tháng";
        case "ticketPeriodic":
          return "Nhận xét định kỳ";
      }
    }
  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/.el-image__error {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ffffff;
  vertical-align: middle;
}

/deep/.el-image__inner {
  object-fit: cover;
}

.app_name {
  display: inline-block;
  margin: 0;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0 12px;
  cursor: not-allowed;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>
